export default {
  init() {
    $(document).ready(function () {

      // eslint-disable-next-line no-undef, no-unused-vars
      // function do_sub(){
        $('#page-registration-submit').on('click', function (event) {
          event.preventDefault();

          let phoneno = $('#mobile').val().replace(/\(/, '');
          let filter = /^\d*(?:\.\d{1,2})?$/;

          phoneno = phoneno.replace(/\)/, '-');
          phoneno = phoneno.replace(/\s+/g, '-').toLowerCase();
          phoneno = phoneno.replace(/-/g, '');

          if ($('#company').val() == '') {
            alert('Company Name is required!');
          } else if ($('#firstname').val() == '' || $('#lastname').val() == '') {
            alert('First and Last Name required!');
          }
          else if (!filter.test(phoneno) || $('#mobile').val() == '') {
            alert('A valid Mobile Phone number is required!');
          } else{
            phoneno = phoneno.replace(/(\d{3})-?(\d{3})-?(\d{4})/,'$1-$2-$3');
            $('#mobile').val(phoneno);
            document.email_form.submit();
          }
        })
      // }
    });
  },
  finalize() {
  },
};
